<div [id]="artifact.id" class="card ms-2 me-2 ms-md-0 me-md-0 mb-3 pt-3">
  <div class="d-flex align-items-center justify-content-between">
    <div class="me-3 d-flex align-items-center">
      <h4 class="mb-0 me-2">
        @if (artifact.version) {
          <span>{{ artifact.version }}</span>
        }
        @if (!artifact.version) {
          <span>{{ 'software.unidentifiedVersion' | translate }}</span>
        }
        @if (artifact.size) {
          <span> ({{ artifact.size | fileSize }})</span>
        }
      </h4>
      @if (artifact.releaseType) {
        <span class="badge release-type-label me-2">{{
          artifact.releaseType!.name
        }}</span>
      }
      @if (artifact.status === SoftwareArtifactStatus.WITHDRAWN) {
        <span class="badge withdrawn-label me-2">{{
          'software.artifact.statusItems.withdrawn' | translate
        }}</span>
      }
    </div>
    <div class="align-self-start">
      @if (artifact.status !== SoftwareArtifactStatus.WITHDRAWN) {
        <app-software-artifact-download-button
          [artifact]="artifact"
          [hierachyLevel]="ButtonHierarchyLevel.SECOND"
          class="me-2"
        ></app-software-artifact-download-button>
      }
      <a [routerLink]="[artifact.id]" target="_blank" class="artifact-link">
        <span class="material-symbols-outlined">link</span>
      </a>
    </div>
  </div>
  @if (artifact.buildNumber) {
    <span
      ><b>{{ 'software.artifact.buildNumber' | translate }}</b
      >: {{ artifact.buildNumber }}</span
    >
  }
  @if (isAdmin) {
    @if (artifact.branchName) {
      <span
        ><b>{{ 'software.artifact.branchName' | translate }}</b
        >: {{ artifact.branchName }}</span
      >
    }
    @if (artifact.creationDate) {
      <span
        ><b>{{ 'software.artifact.creationDate' | translate }}</b
        >: {{ artifact.creationDate | dateTime }}</span
      >
    }
  }
  @if (
    artifact.releaseDate && artifact.status === SoftwareArtifactStatus.RELEASED
  ) {
    <span
      ><b>{{ 'software.artifact.releaseDate' | translate }}</b
      >: {{ artifact.releaseDate | dateTime }}</span
    >
  }
  <ng-container>
    <span>
      @if (firmwareBundles.length > 0) {
        <a
          data-bs-toggle="collapse"
          class="me-2"
          [href]="'#' + artifact.id + '_firmware_bundle'"
          role="button"
          aria-expanded="false"
          >{{ 'software.toggleFirmwareBundle' | translate }}</a
        >
      }
      @if (artifact.changelog && !showChangelogAlways) {
        <a
          data-bs-toggle="collapse"
          class="me-2"
          [href]="'#' + artifact.id + '_changelog'"
          role="button"
          aria-expanded="false"
          >{{ 'software.toggleChangelog' | translate }}</a
        >
      }
      @if (isAdmin && editable) {
        <button class="btn btn-link p-0" (click)="edit.emit()">
          {{ 'edit' | translate }}
        </button>
      }
    </span>
    @if (firmwareBundles.length > 0) {
      <div class="collapse" [id]="artifact.id + '_firmware_bundle'">
        <div class="d-flex flex-column text-addition">
          <label [for]="'hardware-version-selector-' + artifact.id"
            ><b>{{
              'software.artifact.firmwareBundle.hardwareVersionSelector'
                | translate
            }}</b></label
          >
          <p-select
            [inputId]="'hardware-version-selector-' + artifact.id"
            class="mb-2"
            [ngModel]="selectedHardwareVersion ?? hardwareVersionOptions[0]"
            (ngModelChange)="onHardwareVersionChange($event)"
            [options]="hardwareVersionOptions"
            [fluid]="true"
          >
            <ng-template let-hardwareVersionOption pTemplate="selectedItem">
              @if (hardwareVersionOption === noHardwareVersionOptionValue) {
                {{
                  'software.artifact.firmwareBundle.hardwareVersionUnknown'
                    | translate
                }}
              } @else {
                {{ hardwareVersionOption }}
              }
            </ng-template>
            <ng-template let-hardwareVersionOption pTemplate="item">
              @if (hardwareVersionOption === noHardwareVersionOptionValue) {
                {{
                  'software.artifact.firmwareBundle.hardwareVersionUnknown'
                    | translate
                }}
              } @else {
                {{ hardwareVersionOption }}
              }
            </ng-template>
          </p-select>
          @if (selectedFirmwareBundle; as selectedBundle) {
            @if (selectedBundle.bundleName) {
              <span
                ><b>{{
                  'software.artifact.firmwareBundle.bundleName' | translate
                }}</b
                >: {{ selectedBundle.bundleName }}</span
              >
            }
            @if (selectedBundle.hardwareVersion) {
              <span
                ><b>{{
                  'software.artifact.firmwareBundle.hardwareVersion' | translate
                }}</b
                >: {{ selectedBundle.hardwareVersion }}</span
              >
            }
            @if (selectedBundle.firmwareVersion) {
              <span
                ><b>{{
                  'software.artifact.firmwareBundle.firmwareVersion' | translate
                }}</b
                >: {{ selectedBundle.firmwareVersion }}</span
              >
            }
            @if (selectedBundle.bootloaderVersion) {
              <span
                ><b>{{
                  'software.artifact.firmwareBundle.bootloaderVersion'
                    | translate
                }}</b
                >: {{ selectedBundle.bootloaderVersion }}</span
              >
            }
            @if (selectedBundle.bleFirmwareVersion) {
              <span
                ><b>{{
                  'software.artifact.firmwareBundle.bleFirmwareVersion'
                    | translate
                }}</b
                >: {{ selectedBundle.bleFirmwareVersion }}</span
              >
            }
            @if (selectedBundle.bleScriptVersion) {
              <span
                ><b>{{
                  'software.artifact.firmwareBundle.bleScriptVersion'
                    | translate
                }}</b
                >: {{ selectedBundle.bleScriptVersion }}</span
              >
            }
            @if (selectedBundle.imagerFirmwareVersion) {
              <span
                ><b>{{
                  'software.artifact.firmwareBundle.imagerFirmwareVersion'
                    | translate
                }}</b
                >: {{ selectedBundle.imagerFirmwareVersion }}</span
              >
            }
            @if (selectedBundle.touchFirmwareVersion) {
              <span
                ><b>{{
                  'software.artifact.firmwareBundle.touchFirmwareVersion'
                    | translate
                }}</b
                >: {{ selectedBundle.touchFirmwareVersion }}</span
              >
            }
          }
        </div>
      </div>
    }
    @if (artifact.changelog) {
      <div
        class="collapse"
        [id]="artifact.id + '_changelog'"
        [ngClass]="{ show: showChangelogAlways }"
      >
        <markdown [data]="artifact.changelog"></markdown>
      </div>
    }
  </ng-container>
</div>
